import TrimmedVideo from "./TrimmedVideo";

interface RevealLayerProps {
  burnedSrc: string;
  greenSrc: string;
  shifted: boolean;
  cursorX: number;
  cursorY: number;
  greenTrimStart?: number;
  greenTrimEnd?: number | null;
  burnedTrimStart?: number;
  burnedTrimEnd?: number | null;
}

const SPOTLIGHT_R = 420;

export default function RevealLayer({
  burnedSrc,
  greenSrc,
  shifted,
  cursorX,
  cursorY,
  greenTrimStart = 0,
  greenTrimEnd = null,
  burnedTrimStart = 0,
  burnedTrimEnd = null,
}: RevealLayerProps) {
  // When NOT shifted: base = burned, reveal shows green
  // When shifted: base = green, reveal shows burned
  const revealVideoIsGreen = !shifted;

  const maskGradient = `radial-gradient(circle ${SPOTLIGHT_R}px at ${cursorX}px ${cursorY}px, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 25%, rgba(0,0,0,0.7) 45%, rgba(0,0,0,0.4) 62%, rgba(0,0,0,0.18) 78%, rgba(0,0,0,0.06) 90%, rgba(0,0,0,0) 100%)`;

  return (
    <div
      className="absolute inset-0 z-30 pointer-events-none overflow-hidden"
      style={{
        maskImage: maskGradient,
        WebkitMaskImage: maskGradient,
        willChange: "mask-image",
      }}
    >
      <TrimmedVideo
        src={greenSrc}
        trimStart={greenTrimStart}
        trimEnd={greenTrimEnd}
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover transition-opacity duration-[1400ms] ease-out"
        style={{ opacity: revealVideoIsGreen ? 1 : 0 }}
      />
      <TrimmedVideo
        src={burnedSrc}
        trimStart={burnedTrimStart}
        trimEnd={burnedTrimEnd}
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover transition-opacity duration-[1400ms] ease-out"
        style={{ opacity: revealVideoIsGreen ? 0 : 1 }}
      />
    </div>
  );
}